import { Card } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import DataHandlerTable from "src/components/data-handler/table";
import Map from "src/components/map";
import PaginationButtons from "src/components/pagination";
import ActionDialog from "./ActionDialog";
import DataFilter from "./filter";
import useFilter from "./hooks/use-filter";
import useApproval from "./hooks/use-approval";
import Row from "./row";
import ReasonForm from "./reasonForm";
import TableMenu from "src/components/tableMenu";
import RetailActions from "./RetailActions";
import Scrollbar from "src/components/Scrollbar";
const headers = [
  "No",
  "Username",
  // "Email",
  "First Name",
  "Last Name",
  "Status",
  "Address",
  "Remark",
  "Date",
  "Stocks",
  "Action",
  " ",
];

const Orders = () => {
  const methods = useFilter();

  const filter = methods.watch();

  const { state, fetchData, rowStart, ...rest } = useApproval(filter);
  const onFilter = methods.handleSubmit((inputData) => {
    fetchData(1, inputData);
  });
  const { data, ...dataProps } = state;
  const [approved, setApproved] = useState();
  const [rejected, setRejected] = useState();
  const [selectedId, setSelectedId] = useState();
  const [openMenu, setOpenMenu] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleOpenMenu = (id) => (event) => {
    setSelectedUserId(id);
    setOpenMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleOpenApproved = (id) => {
    setSelectedId(id);
    setApproved(true);
  };
  const handleCloseApproved = () => {
    setApproved(false);
  };
  const handleOpenRejected = (id) => {
    setSelectedId(id);
    setRejected(true);
  };
  const handleCloseRejected = () => {
    setRejected(false);
  };

  const { t } = useTranslation();
  return (
    <>
      <Card sx={{ pt: 1 }}>
        <DataFilter onFilter={onFilter} methods={methods} />
        <Scrollbar>
        <DataHandlerTable
          name="category-table"
          dataProps={{ ...dataProps }}
          headers={headers}
        >
          <Map
            list={data}
            render={(item, i) => (
              <Row
                handleOpenMenu={handleOpenMenu}
                handleOpenApproved={handleOpenApproved}
                handleOpenRejected={handleOpenRejected}
                item={item}
                rowNumber={i + rowStart}
              />
            )}
          />
        </DataHandlerTable>
        </Scrollbar>
      </Card>
      <PaginationButtons {...rest} />
      <TableMenu open={openMenu} onClose={handleCloseMenu}>
        <RetailActions selectedId={selectedUserId} />
      </TableMenu>
      <ActionDialog
        fetchData={fetchData}
        title={t("Approve")}
        statusKyc="approved"
        selectedId={selectedId}
        onClose={handleCloseApproved}
        open={approved}
      />
      <ReasonForm
        fetchData={fetchData}
        title={t("Reject")}
        selectedId={selectedId}
        onClose={handleCloseRejected}
        open={rejected}
      />
    </>
  );
};

export default Orders;
